export default __webpack_public_path__ + "static/media/zalo-rating.dc4dee4b.png";